import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import {
  HistoricoFeriasService
} from "../../../services/HistoricoFeriasService";
import { FeriasService } from "../../../services/FeriasService";

import { TIPO_DE_FERIAS } from "../../../constants";


import moment from "moment";
import { FeriasCivilService } from "../../../services/FeriasCivilService";

export default {
  name: "HistoricoFerias",

  components: {
    TextField,
    SelectField,
    PeriodoField
  },

  data: () => ({
    headers: [
      {
        text: "Usuário",
        value: "usuario",
      },
      {
        text: "Exercício",
        value: "exercicio",
      },
      {
        text: "Período de Férias",
        value: "periodo_ferias_atual",
      },
      {
        text: "Dias Cassados",
        value: "dias_cassados",
      },
      {
        text: "Dias Convocados",
        value: "dias_convocados",
      },
      {
        text: "Dias Gozados",
        value: "dias_gozados",
      },
      {
        text: "Dias para Vantagem",
        value: "dias_vantagem",
      },
      {
        text: "Fez Jus ao Abono?",
        value: "status_abono",
      },
      {
        text: "Tipo Histórico",
        value: "tipo_historico",
      },
      {
        text: "Justificativa",
        value: "justificativa",
      },
    ],    

    items: [],
    itemTemporario:[],
    itemComplementares: [],
    pessoa:[],
    page: 1,
    pageCount: 0,
    disabled:true,

    ferias:[],



    selected: [],
    selectedAction: {},
    singleSelect: false,
    idSelected: null,

    filter: {},

    optionsFilter: {
      status: [],
      exercicio: [],
      tipoFerias: [],
      abono:[{text:"Sim", value:"1"}, {text:"Não", value:"0"}]
    },
    loading: {
      table: false,
      btn: false,
      field: false,
    }
  }),

  beforeMount() {
    this.ferias = this.$route.params.ferias;
    },

  async mounted() {
    await this.getHistoricoSolicitante();
    await this.getHistoricoSolicitante();
    this.initializeOptions();
    this.$forceUpdate()

  },

  watch: {
    page: async function(val) {

      if(this.disabled){
        this.page = val;
        await this.getHistoricoSolicitante();

      }else{
        this.page = val;
        await this.getHistoricoComplementar();

      }

    }
  },

  methods: {
    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
        numeroBM: null,
        status: null,
        dataCassacaoInicio: null,
        dataCassacaoFim: null,
        diasCassados: null,
        diasConvocados: null,
        diasAbono: null,
        diasVantagem: null,
        diasGozo: null,
        juzAbono: null


      }
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("page", this.page);
      
      this.filter.tipoFerias ? filter.append("tipo_ferias", this.filter.tipoFerias) : null;
      this.filter.status ? filter.append("status_ferias", this.filter.status) : null;
      this.filter.dataInicio ? filter.append("data_ini", moment(this.filter.dataInicio).format("YYYY-MM-DD")) : null;
      this.filter.dataFim ? filter.append("data_fin", moment(this.filter.dataFim).format("YYYY-MM-DD")) : null;
      this.filter.exercicio ? filter.append("exercicio", this.filter.exercicio) : null;
      this.filter.juzAbono ? filter.append("abono", this.filter.juzAbono) : null;

      this.filter.nomeSubstituto ? filter.append("nome_substituto", this.filter.nomeSubstituto) : null;
      this.filter.diasCassados ? filter.append("juz_abono", this.filter.juzAbono) : null;
      this.filter.diasCassados ? filter.append("dias_cassados", this.filter.diasCassados) : null;
      this.filter.diasAbono ? filter.append("dias_abono", this.filter.diasAbono) : null;
      this.filter.diasVantagem ? filter.append("dias_vantagem", this.filter.diasVantagem) : null;
      this.filter.diasGozo ? filter.append("dias_gozados", this.filter.diasGozo) : null;

      return filter;

    },

    async pesquisarHistorico(){
      if(this.disabled){
        await this.getHistoricoSolicitante()
        return;
      }
      await this.getHistoricoComplementar()
    },

    trocarHistoricoFerias(name){
      this.$router.push({ name: name, params:{ferias: this.ferias} })
    },

    async getHistoricoSolicitante() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await HistoricoFeriasService.pesquisar(filter, this.ferias.idSigrh);
      this.items = response.historico;
      this.pessoa = response.pessoa
      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
      this.$forceUpdate();
    },

    async getHistoricoComplementar() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await HistoricoFeriasService.historicoComplementar(filter, this.ferias.idSigrh);

      this.itemComplementares = response.historico
      this.itemTemporario = this.items;
      this.items = this.itemComplementares

      this.pageCount = response.last_page;
      this.totalItems = response.total;
      this.loading.table = false;
    },

    async getExercicioItems() {
      //this.loading.field = true;
      const response = await HistoricoFeriasService.getExercicio(this.ferias.idSigrh);
      this.optionsFilter.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" })
      //this.loading.field = false;
    },

    async getStatusItems() {
      //this.loading.field = true;
     const response = this.$store.state.user.Civil ? await FeriasCivilService.getStatus() : await FeriasService.getStatus();

      this.optionsFilter.status = response.map(el => {
        return {
          text: el.tipo_status,
          value: el.id,
        }
      });
      this.optionsFilter.status?.unshift({ text: "Selecione", value: "" });
      //this.loading.field = false;
    },

    customSort(items, index, isDesc) {
      const sortedItems = [...items];
      if (index[0] === 'periodo_ferias') {
        sortedItems.sort((a, b) => {
          const formatDate = (dateString) => {
            const [date, time] = dateString.split(" ");
            const [day, month, year] = date.split("/");
            const [hours, minutes, seconds] = time.split(":");
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          };
          const dateA = new Date(formatDate(a[index]));
          const dateB = new Date(formatDate(b[index]));
          return dateA - dateB;
        });
      }
      if (index[0] === 'periodo_ferias' || index[0] === 'periodo_doacao_sangue' ) {
        sortedItems.sort((a, b) => {
          const formatDate = (dateString) => {
            const [startDate] = dateString.split(" à ");
            const [startDay, startMonth, startYear] = startDate.split("/");
            return `${startYear}-${startMonth}-${startDay}`
          };

          const dateA = new Date(formatDate(a[index]));
          const dateB = new Date(formatDate(b[index]));
          return dateA - dateB 
        });
  
    }else {
        sortedItems.sort((a, b) => {
          const valueA = a[index] ? a[index].toString().toLowerCase() : '';
          const valueB = b[index] ? b[index].toString().toLowerCase() : '';
          return valueA.localeCompare(valueB);
        });
      }

      return isDesc[0] ? sortedItems.reverse() : sortedItems;
    },


    initializeOptions(){
      this.getExercicioItems();
      this.getStatusItems();
      this.optionsFilter.tipoFerias= TIPO_DE_FERIAS;
      this.optionsFilter.tipoFerias?.unshift({ text: "Selecione", value: "" });
    },

    async infoComplementar() {    
      this.disabled = false
      this.page = 1;
      await this.getHistoricoComplementar();  
      this.headers = [{
          text: "Autor da ação",
          value: "nome_fez_acao",
        },
        {
          text: "Data/Hora",
          value: "historico_ferias_data_hora",
        },
        {
          text: "Ação Realizada",
          value: "tipo_ferias",
        },
        {
          text: "Exercício",
          value: "exercicio",
        },
        {
          text: "Status",
          value: "tipo_status",
          
        },
        {
          text: "Justificativa",
          value: "justificativa",
          
        },
        // {
        //   text: "Atos Gerados",
        //   value: "TP",
        //   
        // },
      ]
    },

    async informacoesSolicitante() {
      this.disabled = true
      this.page = 1;
      this.itemComplementares = this.items;
      this.items = this.itemTemporario;
      await this.getHistoricoSolicitante();
      this.headers = [
        {
          text: "Usuário",
          value: "usuario",
        },
        {
          text: "Exercício",
          value: "exercicio",
        },
        {
          text: "Período de Férias",
          value: "periodo_ferias_atual",
        },
        {
          text: "Dias Cassados",
          value: "dias_cassados",
        },
        {
          text: "Dias Convocados",
          value: "dias_convocados",
        },
        {
          text: "Dias Gozados",
          value: "dias_gozados",
        },
        {
          text: "Dias para Vantagem",
          value: "dias_vantagem",
        },
        {
          text: "Fez Jus ao Abono?",
          value: "status_abono",
        },
        {
          text: "Tipo Histórico",
          value: "tipo_historico",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
      ]
  }
  }
};